export default {
  nextRequest: {},
  authAction: {},
  actionCall: {},
};
